/**
 * [pug template]
 */
<template lang="pug">
  .selection-alt-choice-container(:class="cssClasses")
      label.selection-alt-choice-container-item(v-for="value, valueRef in options", :value="valueRef", :for="valueRef", v-if="value.display", :disabled="value.disabled", :class="{ 'disabled': value.disabled }")
        //- .check-mark
        .selection-alt-choice-picture-container(v-if="checkLegacyOptions(valueRef)")
          //- .selected-img-check(v-if="(selected === valueRef)", v-html="'&#10004;'")
          img(:src="value.picture" :class="{ 'out-of-stock': true, 'selected': (selected === valueRef) , 'single': (Object.keys(options).length == 1),'bande-img': (valueRef === 'OPT-223_127-mm'),'full-width': (fullWidth !== false) }")
            //- .selected-img-check(v-if="(selected === valueRef)")
          input(type="radio", :id="valueRef", :name="valueRef", :value="valueRef", v-model="selected", v-if="value.display", :disabled="value.disabled")
          label(v-if="checkLabelVisibility(valueRef)" v-text="value.label" :class="{ 'selected': (selected === valueRef) }")
</template>
/**
 * [javascript application]
 */
<script>
export default {
  name: 'select-with-picture-component',
  props: {
    name: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: [Array, Object],
      default: { label: '', display: true, disabled: false }
    },
    defaultField: {
      type: [String, Number],
      default: null
    },
    hideLabel: {
      type: Boolean,
      default: false
    },
    fullWidth: {
      type: Boolean,
      default: true
    },
    cssClasses: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      selected: null
    }
  },
  created: function () {
    this.selected = this.defaultField
  },
  watch: {
    selected: function (newValue, oldValue) {
      var dataEmit = newValue
      this.$emit('value-changed', dataEmit)
    },
    defaultField: function (newValue, oldValue) {
      this.selected = newValue
    }
  },
  methods: {
    checkLegacyOptions: function (opt) {
      var legacyOptions = ['OPT-249_fixations-plafond', 'OPT-250_equerre-80-160-mm', 'OPT-251_fixations-plafond', 'OPT-252_equerres-60-108-mm', 'OPT-253_equerres-108-156-mm']
      return !legacyOptions.includes(opt)
    },
    checkLabelVisibility: function (optRef) {
      if (this.hideLabel) {
        switch (optRef) {
          case 'OPT-1219_sangle':
          case 'OPT-1220_treuil':
          case 'OPT-1221_tirage-direct-avec-verrou':
            return true
          default:
            return false
        }
      }
      return true
    }
  }
}
</script>
/**
 * [scss styles]
 */
<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// SelectWithPictureComponent.vue?42de315b